import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { useSEO } from "@/hooks/useSEO";

export default function NotFound() {
  const { lang } = useLang();
  const isEn = lang === "en";

  useSEO({
    title: isEn ? "Page not found | Arteconciencia" : "Página no encontrada | Arteconciencia",
    description: "Arteconciencia — arte contemporáneo, cultura y concientización desde El Salvador.",
    noindex: true,
  });

  return (
    <main className="bg-paper min-h-screen flex items-center" data-testid="not-found-page">
      <div className="mx-auto max-w-[1180px] px-5 md:px-10 py-32">
        <span className="eyebrow text-ink-mute inline-flex items-center gap-3 mb-6">
          <span className="w-6 h-px bg-latir-red inline-block" />
          Error 404
        </span>
        <h1
          className="font-display text-[2.1rem] sm:text-[3rem] leading-[1.05] text-ink max-w-[18ch]"
          data-testid="not-found-title"
        >
          {isEn ? "Page not found" : "Página no encontrada"}
        </h1>
        <p className="mt-6 font-editorial text-[1.05rem] leading-[1.5] text-ink-soft max-w-[48ch]">
          {isEn
            ? "The page you are looking for does not exist or was moved."
            : "La página que buscas no existe o fue movida."}
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="mt-8 inline-flex items-center gap-2 font-ui uppercase tracking-[0.18em] text-[0.7rem] border border-ink px-5 py-3 hover:bg-ink hover:text-paper transition-colors"
        >
          {isEn ? "Back to home" : "Volver al inicio"}
        </Link>
      </div>
    </main>
  );
}
